import {
  Box,
  createStyles,
  InputBase,
  makeStyles,
  styled,
  TablePagination,
  withStyles,
} from '@material-ui/core';
import { color } from '../../theme';


const useStyles = makeStyles(theme => ({
  // TableComponent Styling
  detailPanel: {
    paddingLeft: 90,
    paddingRight: 90,
    paddingTop: 24,
    paddingBottom: 24,
  },
  detailPanelLabel: {
    fontWeight: 'bold',
    marginBottom: 8,
  },
  detailPanelTitle: {
    fontWeight: 'normal',
    paddingTop: 0,
    paddingBottom: 0,
  },
  detailPanelValue: {
    fontWeight: 'bold',
    paddingTop: 0,
    paddingBottom: 0,
  },
  container: {
    paddingLeft: 8,
    paddingRight: 8,
    width: '100%',
  },
  // FilterComponent Styling
  filterContainer: {
    height: '100%',
    width: '315px',
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(3),
  },
  filterTitle: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  filterClear: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    height: '60px',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${color.ui.gray[300]}`,
  },
  // TableToolbarComponent Styling
  toolbarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toolbarIcon: {
    color: theme.palette.text.primary,
  },
  toolbarTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    whiteSpace: 'nowrap',
    color: theme.palette.icon.contrast,
  },
  // SelectComponent Styling
  selectFormControl: {
    margin: `${theme.spacing(1)} 0px`,
    maxWidth: 300,
  },
  selectLabel: {
    transform: 'initial',
    fontWeight: 'bold',
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    '&.Mui-focused': {
      color: theme.palette.text.primary,
    },
  },
  selectFormLabel: {
    transform: 'initial',
    fontWeight: 'bold',
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    '&.Mui-focused': {
      color: theme.palette.text.primary,
    },
  },
  selectChips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  selectChip: {
    margin: 2,
  },
  selectContainer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },
  selectIcon: {
    position: 'absolute',
    right: '4px',
    pointerEvents: 'none',
    color: theme.palette.icon.contrast,
  },
}));

export const StyledBoxContentHeader = styled(Box)({
  '&': {
    // override css for Content Header container
    '& > div': {
      marginBottom: 32,
      '& > div > h2': {
        fontSize: 24,
      },
    },
  },
});

export const BootstrapInput = withStyles(theme =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.icon.disabled}`,
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      fontFamily: 'Helvetica Neue',
      '&:focus': {
        background: theme.palette.background.paper,
        borderRadius: 4,
      },
    },
  }),
)(InputBase);

export const BootstrapPagination = withStyles(theme =>
  createStyles({
    root: {
      "& [class*='MuiIconButton-root']": {
        padding: theme.spacing(1),
      },
      "& [class*='Mui-disabled']": {
        color: theme.palette.text.disabled,
      },
      '& .MuiTypography-caption': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        color: theme.palette.text.primary,
      },
      "& [class*='MuiIconButton-root'] [class*='MuiSvgIcon-root']": {
        fontSize: 21,
        color: theme.palette.icon.active,
      },
    },
    toolbar: {
      paddingRight: theme.spacing(2),
    },
    input: {
      fontSize: 14,
      color: theme.palette.text.secondary,
      paddingRight: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    selectIcon: {
      fontSize: 20,
      marginRight: theme.spacing(1),
      color: theme.palette.icon.contrast,
    },
  }),
)(TablePagination);

export const useRefreshBarStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.border}`,
    display: 'flex',
  },
  copyButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.border}`,
    borderRight: `1px solid ${theme.palette.border}`,
    width: 'fit-content',
    padding: 8,
    marginLeft: 16,
    cursor: 'pointer',
  },
  countdownWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: '0px 16px',
  },
}));

export default useStyles;
